import { DebugSource } from "@/data/source/debug-source";
import { DebugRepository } from "@/domain/repository/debug-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DebugRepositoryImpl implements DebugRepository {
  constructor(private readonly debugSource: DebugSource) {}

  async deleteGuardianWithPatient(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteGuardianWithPatient(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deletePatientWithAllData(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deletePatientWithAllData(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async purgePatient(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.purgePatient(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteActivity(
    screeningId: string,
    dateOfDay: string,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteActivity(screeningId, dateOfDay);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteCalibration(
    screeningId: string,
    dateOfDay: string,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteCalibration(screeningId, dateOfDay);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteFriends(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteFriends(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteCurrencyItems(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteCurrencyItems(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteMissions(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteMissions(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteTutorial(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteTutorial(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async addAllTutorials(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.addAllTutorials(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deleteStory(screeningId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.deleteStory(screeningId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async setSnExpired(loginId: string): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.setSnExpired(loginId);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async setLightEstimationCount(
    screeningId: string,
    dateOfDay: string,
    count: number,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.setLightEstimationCount(
      screeningId,
      dateOfDay,
      count,
    );
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async setActivityIndex(
    screeningId: string,
    dateOfDay: string,
    sessionIndex: number,
    cycleIndex: number,
  ): Promise<SATResult<void, SATError>> {
    const result = await this.debugSource.setActivityIndex(
      screeningId,
      dateOfDay,
      sessionIndex,
      cycleIndex,
    );
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
